/* global Stripe */
import RSVP from 'rsvp';
import SessionStore from 'stores/shared/session';

const stripeFonts = [
  {
    cssSrc: 'https://use.typekit.net/nqz8fvt.css',
  },
];

const StripeService = {
  initialized: false,
  _init(managedAccountToken = null, fonts = stripeFonts) {
    const stripeArgs = [SessionStore.state.get('stripe_publishable_key')];
    if (managedAccountToken) {
      stripeArgs.push({ stripeAccount: managedAccountToken });
    }
    window.stripe = Stripe.apply(this, stripeArgs);
    window.elements = window.stripe.elements({ fonts });
    // Stripe.setPublishableKey(SessionStore.state.get('stripe_publishable_key'));
    this.initialized = true;
  },

  tokenizeCard(cardParams, params) {
    let _this;
    let payload;
    if (this.initialized === false) {
      this._init();
    }

    _this = this;
    payload = this._stripePayload(cardParams, params);

    return new RSVP.Promise((resolve, reject) => {
      Stripe.card.createToken(payload, (status, response) => {
        if (status === 200) {
          resolve(response.id);
        } else {
          reject(_this._stripeError(response.error));
        }
      });
    });
  },

  _stripePayload(cardParams, params) {
    const expirationMonth = cardParams.card_expiration.split(' / ')[0];
    let expirationYear = cardParams.card_expiration.split(' / ')[1];

    if (expirationYear.length === 2) {
      expirationYear = `20${expirationYear}`;
    }

    return {
      name: `${params.booking_request.cardholder_first_name} ${params.booking_request.cardholder_last_name}`,
      number: cardParams.card_number,
      exp_month: expirationMonth,
      exp_year: expirationYear,
      cvc: cardParams.card_cvc,
      address_city: params.booking_request.billing_city,
      address_zip: params.booking_request.billing_zip_code,
      address_country: params.booking_request.billing_country,
      address_line1: params.booking_request.billing_address_line_1,
      address_line2: params.booking_request.billing_address_line_2,
    };
  },

  _paramMap: {
    number: 'card_number',
    exp_month: 'card_expiration',
    exp_year: 'card_expiration',
    cvc: 'card_cvc',
    postalCode: 'postalCode',
  },

  _stripeError(error) {
    const errors = {};
    if (error.param && this._paramMap[error.param]) {
      errors[this._paramMap[error.param]] = [error.message];
    } else {
      errors.card_number = [error.message];
    }

    return errors;
  },
};

export default StripeService;
